// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Oc2B","requiredAsterisk":"Info_requiredAsterisk__2nfbu"};